<template>
  <div class="max-w-6xl mx-auto py-8">
    <div class="fuel-view p-6 pt-0">
      <FuelTransactionList />
    </div>
  </div>
</template>

<script setup lang="ts">
import FuelTransactionList from '@/components/fuel/FuelTransactionList.vue';
</script>
